import { c as _c } from "react/compiler-runtime";
import { useIntegrationOAuthPopup, type IntegrationOAuthChainOptions } from "./useIntegrationOAuthPopup";
interface UseSlackOAuthPopupOptions {
  /** Unique window name so multiple hook instances don't share a popup */
  popupName: string;
  queryKeysToInvalidate: string[][];
  onSuccess?: () => void;
  onError?: (reason: string | null) => void;
  onClose?: () => void;
  onBlocked?: () => void;
  /**
   * Optional second OAuth leg chained into the same popup window — see
   * `useIntegrationOAuthPopup` for the full semantics. Used to kick off the
   * user-account link flow right after a workspace install succeeds.
   */
  chain?: IntegrationOAuthChainOptions;
}
export function useSlackOAuthPopup(options) {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = {
      ...options,
      resultType: "slack-oauth-result"
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useIntegrationOAuthPopup(t0);
}